import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import useAxiosPublic from "../hooks/useAxiosPublic";
import LoadingPage from "../components/Layout/LoadingPage";
import bannerImage from "../assets/infoBg.jpg";
import TalkToUs from "../components/Info/TalkToUs";
import AcademicCalendar from "../components/Info/AcademicCalendar";
import NewsEvents from "../components/Info/NewsEvents";
import PoliciesCompliance from "../components/Info/Policies";

const InfoCenter = () => {
  const axiosPublic = useAxiosPublic();

  const {
    data: infoCenterData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["info"],
    queryFn: async () => {
      const res = await axiosPublic.get("/info-center");
      return res?.data;
    },
  });

  if (isLoading) return <LoadingPage />;
  if (error)
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );

  return (
    <div>
      {/* Banner */}
      <div className="relative w-full z-10 h-[70vh] lg:h-[50vh]">
        <img
          src={bannerImage || "/placeholder.svg"}
          alt="VC Banner"
          className="absolute inset-0 object-cover w-full h-full"
        />
        <div className="absolute inset-0 z-20 w-full h-full bg-gradient-to-r from-primary/90 via-primary/40 to-primary/10"></div>
        <div className="container relative z-20 flex items-center justify-start w-full h-full p-8 mx-auto">
          <div className="text-white">
            <p className="my-4 text-2xl font-semibold">— Info Center</p>
            <h1 className="text-4xl font-bold md:text-5xl lg:text-6xl font-domine">
              Looking for something?
            </h1>
          </div>
        </div>
      </div>

      {/* Sections */}
      <div className="container px-4 py-12 mx-auto lg:py-20 md:px-8">
        <div className="space-y-20 lg:space-y-40">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.1 }}
            transition={{
              staggerChildren: 0.2,
              duration: 0.6,
              ease: "easeInOut",
            }}
            variants={{
              hidden: { opacity: 0, x: -100 },
              visible: { opacity: 1, x: 0 },
            }}
            className="grid grid-cols-1 gap-20 lg:gap-10 lg:grid-cols-2"
          >
            <TalkToUs data={infoCenterData.talk_to_us} />
            <AcademicCalendar data={infoCenterData.academic_calendar} />
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.1 }}
            transition={{
              staggerChildren: 0.2,
              duration: 0.6,
              ease: "easeInOut",
            }}
            variants={{
              hidden: { opacity: 0, x: -100 },
              visible: { opacity: 1, x: 0 },
            }}
            className="grid grid-cols-1 gap-20 lg:gap-10 lg:grid-cols-2"
          >
            <NewsEvents data={infoCenterData.news_and_events} />
            <PoliciesCompliance data={infoCenterData.policies} />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default InfoCenter;
